import type { LocationId } from '@brightlocal/shared';

import { DetailedLocationSummaryResponseSchema } from './schema';
import { HTTP_METHOD } from '../../consts';
import type { ApiCallOptions, Transport } from '../../types';

export const createLocationSummaryApi = (transport: Transport) => ({
  getDetailedLocationSummary: (locationId: LocationId, options?: ApiCallOptions) =>
    transport(`/manage/v1/locations/${locationId}/summaries/detailed`, {
      method: HTTP_METHOD.GET,
      deserializer: DetailedLocationSummaryResponseSchema,
      signal: options?.signal
    })
});

export type LocationSummaryApi = ReturnType<typeof createLocationSummaryApi>;
